export var setValues = function setValues(payload) {
  return {
    type: 'setValues',
    payload: payload
  };
};
export var setErrors = function setErrors(payload) {
  return {
    type: 'setErrors',
    payload: payload
  };
};
export var setFormStatus = function setFormStatus(payload) {
  return {
    type: 'setStatus',
    payload: payload
  };
};
export var resetForm = function resetForm() {
  return {
    type: 'resetForm'
  };
};